// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JFAy","fullView":"styles_fullView__13oKZ"};